module.exports = __webpack_public_path__ + "media/msg_sent.42d7ef27.mp3";